import { render, staticRenderFns } from "./ModalDisclaimer.vue?vue&type=template&id=39fce95c&"
import script from "./ModalDisclaimer.vue?vue&type=script&lang=js&"
export * from "./ModalDisclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports